import { dealTypeFromJsonQuery, FDealType } from '../../../../../packages/JsonQuery';
import { useSelector } from 'react-redux';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { PostfixPopupLink } from 'shared/components/PostfixPopupLink';
import { selectCommercialLink } from 'shared/selectors/commercialLink';

export function OfferTypePopupPostfix() {
  const jsonQuery = useSelector(selectJsonQuery);
  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const commercialLink = useSelector(selectCommercialLink);

  if (dealType === FDealType.RentDaily || !commercialLink) {
    return null;
  }

  return <PostfixPopupLink href={commercialLink} text="Коммерческая" />;
}
